import { stateful } from '@adornis/functional-lit/stateful.js';
import { currentUserSignal } from '@adornis/users/client/currentUser.js';
import { html, nothing } from 'lit';

/** Header badge showing which account is currently logged in. */
export const CurrentUserBadge = stateful(() => {
  // stateful renders inside a preact-signals effect, so reading the signal re-renders on change.
  const email = currentUserSignal.value?.email;
  if (!email) return nothing;
  return html`
    <span
      class="badge badge-ghost badge-sm gap-1 font-normal max-w-[16rem]"
      title="Angemeldet als ${email}"
    >
      <x-icon class="text-sm">account_circle</x-icon>
      <span class="truncate">${email}</span>
    </span>
  `;
});
